import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import omit from 'lodash/omit';

import {
    TextButton,
    Spacer,
    Text,
    Button,
    Switch,
    Checkbox,
} from '@zillow/constellation';
import { HR } from '@zillow/zrs-comet';

import UserPermissionsConstants from 'app/shared/constants/UserPermissionsConstants';
import UserManagementActions from 'app/shared/actions/UserManagementActions';
import { UserManagementSelectors } from 'app/shared/selectors';

import './style.scss';

const propTypes = {
    currentUser: PropTypes.object.isRequired,
};

const PermissionSwitch = ({
    permission,
    description,
    active,
    onPermissionChange,
}) => (
    <div className="AddUserPage-list-box-item flex">
        <div className="AddUserPage-list-header">
            <Text>{description}</Text>
        </div>
        <div>
            <Switch
                checkbox={<Checkbox checked={active} />}
                onClick={() => onPermissionChange(permission, !active)}
            />
        </div>
    </div>
);

const Permissions = ({
    onCancel,
    onBack,
    onNextStep,
    dispatch,
    handleSaveComplete,
    currentUser,
}) => {
    const { isInvitation } = currentUser;

    const otherPermissions = omit(UserPermissionsConstants.PERMISSIONS, [
        UserPermissionsConstants.PERMISSIONS.COMPANY_ADMIN,
        UserPermissionsConstants.PERMISSIONS.SYNC_PROPERTIES,
        UserPermissionsConstants.PERMISSIONS.COMPANY_USER,
    ]);

    const handleUpdatePermission = (permission) => {
        const newPermissions = {
            ...currentUser.permissions,
            [permission]: !currentUser.permissions[permission],
        };
        dispatch(UserManagementActions.currentUserSetPermissions(newPermissions));
    };

    return (
        <div>
            <Spacer marginY="sm">
                <Text fontType="bodyHeading">{`Set ${currentUser.userName}'s permissions`}</Text>
            </Spacer>
            <div className="AddUserPage-list-box">
                <div className="AddUserPage-list-box-body">
                    {Object.keys(otherPermissions).map(permission => (
                        <PermissionSwitch
                            key={permission}
                            permission={permission}
                            onPermissionChange={() => handleUpdatePermission(permission)}
                            title={UserPermissionsConstants.DESCRIPTION[permission].TITLE}
                            description={UserPermissionsConstants.DESCRIPTION[permission].DESCRIPTION}
                            active={currentUser.permissions[permission]}
                        />
                    ))}
                </div>
            </div>
            <HR />
            <div className="Questions-footer">
                <TextButton className="Questions-button" onClick={onCancel}>
                    Cancel
                </TextButton>
                <div>
                    <TextButton className="Questions-button" onClick={onBack}>
                        Back
                    </TextButton>
                    {isInvitation
                        ? (
                            <Button buttonType="primary" onClick={onNextStep}>
                                Continue
                            </Button>
                        )
                        : (
                            <Button
                                buttonType="primary"
                                onClick={() => dispatch(UserManagementActions.editableUserSave())
                                    .then(handleSaveComplete)}
                            >
                                Save
                            </Button>
                        )}
                </div>
            </div>
        </div>
    );
};

Permissions.propTypes = propTypes;

const mapStateToProps = state => ({
    currentUser: UserManagementSelectors.makeCurrentUser(state),
});

export default connect(mapStateToProps)(Permissions);
